module.exports = __webpack_public_path__ + "img/c-matrix.22b14066.png";